module.exports = __webpack_public_path__ + "7cd21d296607474a8299964b82cce762.otf";